<div data-test-id="wrap-search-input-field" class="flex-md-grow-1 w-100 mt-2 me-3">
  <label data-test-id="input-label" class="form-label" for="search-input-field"> {{ label | translate }}</label>

  <div class="position-relative">
    <input
      type="text"
      id="search-input-field"
      class="form-control"
      data-test-id="search-input-field"
      [value]="value"
      [placeholder]="placeholder | translate"
      appDebounceKeyboardKeyup
      (debounceKeyUp)="onValueChanges($event)"
    />

    <i class="position-absolute" style="top: 0px; right: 10px; cursor: pointer; z-index: 100">
      <svg-icon
        src="assets/icons/icon-cross.svg"
        data-test-id="clear-btn"
        (click)="onClearInput()"
        class="btn btn-link icon-cross"
      ></svg-icon>
    </i>
  </div>
</div>
